import { isAbsent } from "lib/utils"
import { useSelector } from "react-redux"
import { selectUserToken } from "store/auth"

type Props = {
  onOpenModal: () => void,
  deliveryAddress: string,
  className?: string
  setIsOpenCb: React.Dispatch<React.SetStateAction<boolean>>
}

const HeaderAddress = ({ onOpenModal, deliveryAddress, className = '', setIsOpenCb }: Props) => {
  let userToken = useSelector(selectUserToken)

  const handleOpen = () => {
    if (isAbsent(userToken)) {
   setIsOpenCb((prev) => !prev)
    } else {
onOpenModal()
    }
  }

  return (
    <div onClick={handleOpen} className={`h-[40px] bg-[#F4F4F4] max-w-[250px] lg:max-w-[220px] sm:cursor-pointer px-[9.3px] rounded-[18.6px] inline-flex gap-[2px] items-center ${className}`}
    >
      <div className='h-[22px] w-[22px] min-w-[22px]'>
        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_13305_115033)">
            <path d="M16.4594 4.16266C17.2312 3.83187 18.0116 4.61228 17.6808 5.38411L12.1466 18.2972C11.7666 19.1839 10.4544 18.9773 10.3654 18.0167L9.88178 12.8023C9.84044 12.3564 9.48731 12.0033 9.04145 11.9619L3.82659 11.4782C2.86602 11.3891 2.65938 10.0769 3.54608 9.69692L16.4594 4.16266Z" fill="#FF6262" />
          </g>
          <defs>
            <clipPath id="clip0_13305_115033">
              <rect width="22.3256" height="22.3256" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className='h-[20px]  items-center text-[14px] lg:text-[15px] font-semibold text-[#202020] leading-[20px] lg:leading-[22px] truncate'>
        {deliveryAddress}
      </div>
    </div>
  )
}

export default HeaderAddress
